module.exports = __webpack_public_path__ + "static/media/unFocusedVoice.4274525a.svg";